import { ClassEnum, SETTING_TYPE } from '@/constants/enum';
import useRequiredMessage from '@/hooks/useRequiredMessage';
import { previewOptionSelector } from '@/redux/slice/preview.slice';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { ITexts } from '@/types/components/translation';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const RequireMessage = () => {
  const previewOptions = useSelector(previewOptionSelector);
  const widgetTextDetail = useSelector(widgetTextDetailSelector);
  const widgetSettings = useSelector(widgetSettingSelector);

  const { isShowRequiredMessage } = useRequiredMessage();

  const requiredMessage = useMemo(() => {
    const key: keyof NonNullable<ITexts['requiredConditions']> =
      widgetSettings?.widgetPosition?.displayOnPage?.[0] === 'cart' ? 'beforeCheckout' : 'beforeAddToCart';
    let requiredMessage: string | undefined;
    switch (previewOptions.methods.find((item) => item.selected)?.key) {
      case SETTING_TYPE.SHIPPING:
        requiredMessage = widgetTextDetail?.texts?.find((item) => item.type === SETTING_TYPE.SHIPPING)?.requiredConditions?.[key];
        break;
      case SETTING_TYPE.DELIVERY:
        requiredMessage = widgetTextDetail?.texts?.find((item) => item.type === SETTING_TYPE.DELIVERY)?.requiredConditions?.[key];
        break;
      case SETTING_TYPE.PICKUP:
        requiredMessage = widgetTextDetail?.texts?.find((item) => item.type === SETTING_TYPE.PICKUP)?.requiredConditions?.[key];
        break;
      default:
        break;
    }

    return requiredMessage;
  }, [previewOptions.methods, widgetSettings?.widgetPosition?.displayOnPage, widgetTextDetail?.texts]);

  if (!isShowRequiredMessage || !requiredMessage) return null;

  return <div className={ClassEnum.RequiredMessage} dangerouslySetInnerHTML={{ __html: requiredMessage }}></div>;
};

export default RequireMessage;
